module.exports = __webpack_public_path__ + "static/img/2.b71bef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-1/2.jpg
// module id = Euka
// module chunks = 0